import { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Department from "../pages/Department";
import Dashboard from "../pages/Dashboard";
import Category from "../pages/Category";
import Group from "../pages/Group";
import Archive from "../pages/Archive";
import Trash from "../pages/Trash";
import Setting from "../pages/Setting";
import ChangePassword from "../pages/Changepassword";
import Changemasterheader from "../pages/Changemasterheader";
import Notification from "../pages/Notification";
import UserTaskUpdateForm from "../pages/UserTaskUpdate";
import UserLoginHistory from "../pages/UserLoginHistory";
import UserFrequencyForm from "../pages/UserFrequency";
import LoginPage from "./LoginPage";
import UserCreation from "../pages/UserCreation";
import UserRole from "../pages/UserRole";
import Reports from "../pages/Reports";
import DashboardLayout from "./DashboardLayout";
import Timeline from "../pages/Timeline";
import Selectministrty from "../pages/Selectministry";
import VoiceSearch from '../pages/VoiceSearch';
import NotificationDetail from './NotificationDetail';

export default function AppRoute() {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const roleName = user?.roleName?.toLowerCase();
  const isAdmin = roleName === "admin";
  const isSuperAdmin = roleName === "SuperAdmin";
  const isRestrictedUser =
    roleName === "taskcoordinator" || roleName === "viewer";
  const navigate = useNavigate();

  function NotFoundRedirect() {
    const location = useLocation();

    useEffect(() => {
      const route = location.pathname.split("/");

      console.log(route);
      toast.error(
        `You were logged out. Access to this route '${route[2]}' is restricted."`
      );
      // navigate(-1);
      sessionStorage.removeItem("token");
      navigate("/");
    }, []);

    return null;
  }

  return (
    <Routes>
      {/* Public Route */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/selectministry" element={<Selectministrty />} />
      {/* Protected Dashboard with nested routes */}
      <Route path="/Dashboard" element={<DashboardLayout />}>
        {/* Default dashboard welcome content */}
        <Route index element={<Dashboard />} />

        {/* Department page inside dashboard */}
        {(isAdmin || isSuperAdmin || !isRestrictedUser) && (
          <>
            <Route path="department" element={<Department />} />
            <Route path="category" element={<Category />} />
            <Route path="userCretaion" element={<UserCreation />} />
            <Route path="userRole" element={<UserRole />} />
            <Route path="group" element={<Group />} />
            <Route path="archive" element={<Archive />} />
            <Route path="trash" element={<Trash />} />
            <Route path="setting" element={<Setting />} />
          </>
        )}

        <Route path="reports" element={<Reports />} />
        <Route path="userFrequency" element={<UserFrequencyForm />} />
        <Route path="userLoginHistory" element={<UserLoginHistory />} />
        <Route path="userTaskUpdate" element={<UserTaskUpdateForm />} />
        <Route path="voiceSearch" element={<VoiceSearch />} />
        <Route path="notification" element={<Notification />} />
        <Route path="notification/:id" element={<NotificationDetail />} />
        <Route path="changemasterheader" element={<Changemasterheader />} />
        <Route path="timeline" element={<Timeline />} />

        <Route path="changepassword" element={<ChangePassword />} />
        <Route path="*" element={<NotFoundRedirect />} />
      </Route>
      <Route path="*" element={<NotFoundRedirect />} />
    </Routes>
  );
}
